// extracted by mini-css-extract-plugin
export default {"wrapper":"MainNews_wrapper__mmrap","title":"MainNews_title__HIVzN","post":"MainNews_post__A6tbe","post_img":"MainNews_post_img__X3eBQ","post_title":"MainNews_post_title__VySfy"};